import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  vi: {
    translation: {
      product: "SEO Intelligence",
      auth: {
        title: "Đăng nhập Dashboard",
        subtitle: "Nhập mật khẩu quản trị để xem dữ liệu SEO của agrowth.io.",
        password: "Mật khẩu",
        signIn: "Đăng nhập",
        signingIn: "Đang đăng nhập...",
        invalid: "Mật khẩu không đúng.",
        tooMany: "Đăng nhập sai quá nhiều lần. Vui lòng thử lại sau 15 phút.",
        logout: "Đăng xuất"
      },
      history: {
        title: "Lịch sử thứ hạng",
        subtitle: "Theo dõi vị trí SERP đã lưu theo từng ngày.",
        pageSubtitle: "Theo dõi vị trí, landing page, volume và mở lịch sử từng từ khóa.",
        from: "Từ",
        to: "Đến",
        close: "Đóng",
        position: "Vị trí",
        notFound: "Không tìm thấy",
        empty: "Chưa có dữ liệu thứ hạng trong khoảng ngày này.",
        dataPoints: "điểm dữ liệu",
        tags: "Tags",
        view: "Kiểu hiển thị",
        latestView: "Mới nhất",
        gridView: "Bảng lịch sử",
        exportExcel: "Xuất Excel",
        exporting: "Đang xuất...",
        exported: "Đã xuất {{keywords}} từ khóa và {{days}} ngày lịch sử.",
        exportError: "Không thể xuất Excel. Vui lòng thử lại."
      },
      liveData: "Dữ liệu trực tiếp",
      demoData: "Dữ liệu mẫu",
      nav: {
        overview: "Tổng quan",
        rankings: "Thứ hạng từ khóa",
        traffic: "Lưu lượng tìm kiếm",
        matrix: "Ranking × Traffic",
        movers: "Cơ hội & Cảnh báo",
        sync: "Trạng thái đồng bộ"
      },
      overview: {
        eyebrow: "Search performance command center",
        title: "Từ thứ hạng đến tăng trưởng thực",
        subtitle: "Kết nối tín hiệu SERP và Search Console theo từng thị trường.",
        visibility: "Phân bổ hiển thị",
        trend: "Xu hướng tìm kiếm",
        topKeywords: "Cơ hội nổi bật",
        outsideTop100: "từ khóa hiện ngoài Top 100"
      },
      metrics: {
        clicks: "Clicks",
        impressions: "Impressions",
        ctr: "CTR",
        position: "Vị trí GSC",
        avgRank: "Thứ hạng TB"
      },
      traffic: {
        subtitle: "Phân tích clicks, impressions, CTR và vị trí GSC theo từ khóa, project và thị trường."
      },
      matrix: {
        subtitle: "Nhìn cùng lúc thứ hạng, nhu cầu tìm kiếm và traffic thực theo đúng thị trường.",
        opportunity: "Ưu tiên query có impressions cao, rank 4–20 và CTR còn thấp."
      },
      date: {
        title: "Phạm vi ngày",
        days: "ngày",
        start: "Ngày bắt đầu",
        end: "Ngày kết thúc",
        compare: "So sánh",
        previous: "Kỳ liền trước",
        year: "Cùng kỳ năm trước",
        custom: "Tùy chỉnh",
        cancel: "Hủy",
        apply: "Áp dụng",
        vsPrevious: "so với kỳ liền trước",
        vsYear: "so với cùng kỳ năm trước",
        vsCustom: "so với khoảng ngày tùy chỉnh",
        latestData: "Dữ liệu mới nhất",
        availableDays: "ngày có dữ liệu",
        unsyncedDays: "ngày chưa đồng bộ",
        noAvailableData: "Chưa có ngày dữ liệu để lựa chọn"
      },
      common: {
        allMarkets: "Tất cả thị trường",
        allProjects: "Tất cả nhóm",
        allCategories: "Tất cả loại project",
        rowsPerPage: "Số kết quả mỗi trang",
        last28Days: "28 ngày gần nhất",
        search: "Tìm từ khóa...",
        keyword: "Từ khóa",
        project: "Project",
        market: "Thị trường",
        rank: "Rank",
        change: "Thay đổi",
        volume: "L-Vol",
        traffic: "Traffic",
        status: "Trạng thái",
        updated: "Cập nhật",
        retry: "Chạy đồng bộ",
        loading: "Đang tải dữ liệu...",
        empty: "Chưa có dữ liệu cho bộ lọc này.",
        setup: "Kết nối Worker API để xem dữ liệu thực.",
        previous: "Trước",
        next: "Sau",
        results: "kết quả",
        page: "Trang",
        lightMode: "Giao diện sáng",
        darkMode: "Giao diện tối",
        hideSidebar: "Ẩn thanh điều hướng",
        showSidebar: "Hiện thanh điều hướng"
      }
    }
  },
  en: {
    translation: {
      product: "SEO Intelligence",
      auth: {
        title: "Sign in to Dashboard",
        subtitle: "Enter the administrator password to view agrowth.io SEO data.",
        password: "Password",
        signIn: "Sign in",
        signingIn: "Signing in...",
        invalid: "Incorrect password.",
        tooMany: "Too many failed attempts. Try again in 15 minutes.",
        logout: "Sign out"
      },
      history: {
        title: "Ranking history",
        subtitle: "Track stored SERP positions by date.",
        pageSubtitle: "Track rank, landing page, volume, and open each keyword's history.",
        from: "From",
        to: "To",
        close: "Close",
        position: "Position",
        notFound: "Not found",
        empty: "No ranking data in this date range.",
        dataPoints: "data points",
        tags: "Tags",
        view: "View",
        latestView: "Latest",
        gridView: "History grid",
        exportExcel: "Export Excel",
        exporting: "Exporting...",
        exported: "Exported {{keywords}} keywords and {{days}} history days.",
        exportError: "Could not export Excel. Please try again."
      },
      liveData: "Live data",
      demoData: "Demo data",
      nav: {
        overview: "Overview",
        rankings: "Keyword rankings",
        traffic: "Search traffic",
        matrix: "Ranking × Traffic",
        movers: "Opportunities & Alerts",
        sync: "Sync status"
      },
      overview: {
        eyebrow: "Search performance command center",
        title: "Turn rankings into measurable growth",
        subtitle: "Connect SERP signals and Search Console by market.",
        visibility: "Visibility distribution",
        trend: "Search trend",
        topKeywords: "Priority opportunities",
        outsideTop100: "keywords currently outside Top 100"
      },
      metrics: {
        clicks: "Clicks",
        impressions: "Impressions",
        ctr: "CTR",
        position: "GSC position",
        avgRank: "Average rank"
      },
      traffic: {
        subtitle: "Analyze clicks, impressions, CTR, and GSC position by keyword, project, and market."
      },
      matrix: {
        subtitle: "View ranking, search demand, and real traffic together in the correct market.",
        opportunity: "Prioritize queries with high impressions, rank 4–20, and low CTR."
      },
      date: {
        title: "Date range",
        days: "days",
        start: "Start date",
        end: "End date",
        compare: "Compare",
        previous: "Previous period",
        year: "Same period last year",
        custom: "Custom",
        cancel: "Cancel",
        apply: "Apply",
        vsPrevious: "vs. previous period",
        vsYear: "vs. same period last year",
        vsCustom: "vs. custom date range",
        latestData: "Latest data",
        availableDays: "days with data",
        unsyncedDays: "unsynced days",
        noAvailableData: "No data dates are available to select"
      },
      common: {
        allMarkets: "All markets",
        allProjects: "All projects",
        allCategories: "All project types",
        rowsPerPage: "Results per page",
        last28Days: "Last 28 days",
        search: "Search keywords...",
        keyword: "Keyword",
        project: "Project",
        market: "Market",
        rank: "Rank",
        change: "Change",
        volume: "L-Vol",
        traffic: "Traffic",
        status: "Status",
        updated: "Updated",
        retry: "Run sync",
        loading: "Loading data...",
        empty: "No data for these filters.",
        setup: "Connect the Worker API to view live data.",
        previous: "Previous",
        next: "Next",
        results: "results",
        page: "Page",
        lightMode: "Light mode",
        darkMode: "Dark mode",
        hideSidebar: "Hide sidebar",
        showSidebar: "Show sidebar"
      }
    }
  }
};

void i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("agrowth-language") ?? "vi",
  fallbackLng: "vi",
  interpolation: { escapeValue: false }
});

export default i18n;
